// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3OT68","container":"styles_container__1C4th","title":"styles_title__1uzI4","wrapper":"styles_wrapper__1lZbS","answer":"styles_answer__r1pQG"};